// Meta (Facebook) Pixel helper.
// Loads the fbq base code once, then exposes typed helpers for tracking events.
//
// IMPORTANT: every interaction with the external Facebook script is wrapped in
// try/catch. The pixel loads cross-origin (connect.facebook.net) and, inside a
// sandboxed preview iframe or behind an ad-blocker, it can fail or throw — which
// the browser surfaces as an opaque "Script error." We must never let that
// crash the page, so all pixel calls fail silently.

const PIXEL_ID = '1314522523581352'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base script and initializes the pixel.
 * Safe to call multiple times — it only runs once. Never throws.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return

  try {
    /* eslint-disable */
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      // Swallow load failures (ad-blockers / sandbox) silently.
      t.onerror = () => {}
      const s = b.getElementsByTagName(e)[0]
      s.parentNode?.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq('init', PIXEL_ID)
    initialized = true
  } catch {
    // Pixel failed to initialize — ignore so the app keeps working.
  }
}

/** Fires a standard PageView event. Never throws. */
export function trackPageView(): void {
  try {
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', 'PageView')
  } catch {
    /* no-op */
  }
}

/** Fires a standard AddToCart event. Never throws. */
export function trackAddToCart(params?: Record<string, unknown>): void {
  try {
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', 'AddToCart', params)
  } catch {
    /* no-op */
  }
}
